import React from 'react'
import { Box, Flex, Text } from '@chakra-ui/react';
import { containerStyle, innerContainerStyle } from './constant'; 
import { TermsOfUseTypes } from './TermsOfUseTypes';
import '../../style/termsOfUse/termsOfUse.css'

export const TermsOfUse = ({heading,subHeading,mainDescription,contentList,contactInfoTitle,contactInfo }:TermsOfUseTypes.ITermsOfUseProps) => {

  return (
    <Flex width={'100%'} justifyContent={'center'} className='termsOfUseContainer'>
    <Flex {...containerStyle} className='container'>
      <Text textStyle={'h2'}>{heading}</Text>
      <Text>{subHeading}</Text>
      <Flex direction={'column'} gap={'2rem'}>
        <Box  className='description'>
          <div dangerouslySetInnerHTML={{ __html: mainDescription }}/>
        </Box>
        {
          contentList && contentList.map(({ title, description },index) => {
            return <Flex key={index} {...innerContainerStyle} className='content'>
              {title &&<Text textStyle={'h5'} fontWeight={600}>{title}</Text>}
              {description && <Box dangerouslySetInnerHTML={{ __html: description }} className='description' />}
            </Flex>
          })
        }
        {contactInfoTitle &&<Text textStyle={'h5'} fontWeight={600}>{contactInfoTitle}</Text>}
        {
          contactInfo && contactInfo.map(({ label, data, id , link }) => {
            return <Flex key={id} {...innerContainerStyle} className='content'>
              {<span>
                <span><b>{label}</b></span>
                <a
                    href={link}
                    target='_blank'
                    >
                    <span>
                        {data}
                    </span>
                </a>
                </span>
                }
            </Flex>
          })
        }
      </Flex>
    </Flex>
    </Flex>
  );
}

